import { supabase } from '@/lib/supabase/client';

/** Call a Postgres RPC and throw the raw error (mapped later by toUserMessage). */
export async function rpc<T>(fn: string, args?: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.rpc(fn, args ?? {});
  if (error) throw error;
  return data as T;
}

/** Throw on a supabase-js `{ data, error }` result. */
export function unwrap<T>(result: { data: T | null; error: unknown }): T {
  if (result.error) throw result.error;
  return result.data as T;
}
